import type { NextPage } from 'next';
import ActivateAccount from '@containers/ActivateAccount';
import Head from 'next/head';

const ActivateAccountPage: NextPage = () => {
  return (
    <>
      <Head>
        <title>Activate Your Account - The Cumin Club</title>
      </Head>
      <ActivateAccount />
    </>
  );
};

export default ActivateAccountPage;
